import { render, staticRenderFns } from "./EventEditActionButtons.vue?vue&type=template&id=4c3444e7&scoped=true"
import script from "./EventEditActionButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventEditActionButtons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventEditActionButtons.vue?vue&type=style&index=0&id=4c3444e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3444e7",
  null
  
)

export default component.exports